import { CustomElement } from "../../../core/CustomElement";
import { FontWeight } from "../field/field";

enum TextAlign {
  start = "start",
  center = "center",
  end = "end",
}

export class CCCLabel extends CustomElement {
  static get observedAttributes(): Array<string> {
    return ["label", "text-align", "label-weight"];
  }

  constructor() {
    super();
    this.templateConfig = {
      template: require("./label.html").default,
      style: require("./label.scss").default,
    };
    this.setupComponent();
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: string | null,
    newValue: string | null
  ): void {
    switch (attr) {
      case "label": {
        this.shadowDom.querySelector(".label").innerHTML = newValue;
        break;
      }
      case "text-align": {
        const $container = this.shadowDom.querySelector(".ccc-label");
        switch (newValue) {
          case TextAlign.start: {
            $container.classList.add("align-start");
            $container.classList.remove("align-center");
            $container.classList.remove("align-end");
            break;
          }
          case TextAlign.center: {
            $container.classList.add("align-center");
            $container.classList.remove("align-start");
            $container.classList.remove("align-end");
            break;
          }
          case TextAlign.end: {
            $container.classList.add("align-end");
            $container.classList.remove("align-start");
            $container.classList.remove("align-center");
            break;
          }
        }
        break;
      }
      case "label-weight": {
        const $label = this.shadowDom.querySelector(".label");
        switch (<FontWeight>newValue) {
          case FontWeight.bold:
            $label.classList.add("label-bold");
            break;
          default:
            $label.classList.remove("label-bold");
        }
        break;
      }
    }
  }
}

// define component
if (!customElements.get("ccc-label")) {
  customElements.define("ccc-label", CCCLabel);
}
